// TrackingTabXL - Sprint 44 Fase 3 Vista 10.
// Courier select + numero tracking + boton "Ver tracking" + preview URL.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import { Link } from 'react-router-dom';
import XLInput from '../../../components/xl/XLInput';
import XLSelect from '../../../components/xl/XLSelect';

const CSS_ID = 'xl-imp-track-css';
const CSS = `
.xl-track { display: flex; flex-direction: column; gap: 16px; max-width: 640px; font-family: var(--xl-font-sans) }
.xl-track__row { display: flex; gap: 8px; align-items: end }
.xl-track__row > .xl-track__row-input { flex: 1 }
.xl-track__btn {
  font: 500 13px/1 var(--xl-font-sans); padding: 10px 16px;
  border-radius: var(--xl-radius-md); border: 1px solid transparent;
  background: var(--xl-color-primary); color: var(--xl-color-text-inverse);
  cursor: pointer; white-space: nowrap;
  align-self: flex-end;
}
.xl-track__btn:hover { background: var(--xl-color-primary-hover) }
.xl-track__btn:disabled { opacity: 0.45; cursor: not-allowed }
.xl-track__btn:focus-visible { outline: 2px solid var(--xl-color-focus); outline-offset: 2px }

.xl-track__preview {
  background: var(--xl-color-surface-alt);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-sm);
  padding: 8px 12px;
  font-size: 11px;
  color: var(--xl-color-text-muted);
  word-break: break-all;
}
.xl-track__preview-url { font-family: var(--xl-font-mono); color: var(--xl-color-text); margin-left: 4px }

.xl-track__warn { font-size: 11px; color: var(--xl-color-warning); }
.xl-track__hint { font-size: 11px; color: var(--xl-color-text-muted); }
.xl-track__link { color: var(--xl-color-info); text-decoration: underline }
.xl-track__link:hover { color: var(--xl-color-primary-hover) }
`;

export default function TrackingTabXL({
  form, set, couriers, onVerTracking, courierSeleccionado, isNew,
}) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  const base = (courierSeleccionado && courierSeleccionado.url_base_tracking) || '';
  const previewUrl = base + (form.courier_tracking || '');
  const puedeVer = !isNew && !!base;

  const courierOptions = [
    { value: '', label: 'Selecciona un courier...' },
    ...couriers.map((c) => ({
      value: String(c.id),
      label: c.nombre + (c.pais ? ' (' + c.pais + ')' : ''),
    })),
  ];

  return (
    <div className="xl-track">
      <XLSelect label="Courier"
        value={form.courier_id == null ? '' : String(form.courier_id)}
        onChange={(e) => set('courier_id', e.target.value)}
        options={courierOptions} />

      {couriers.length === 0 && (
        <p className="xl-track__hint">
          No hay couriers todavia. <Link to="/couriers" className="xl-track__link">Crearlos aqui</Link>.
        </p>
      )}

      {form.courier_id && (
        <>
          <div className="xl-track__row">
            <div className="xl-track__row-input">
              <XLInput label="Numero de tracking"
                value={form.courier_tracking || ''}
                onChange={(e) => set('courier_tracking', e.target.value)}
                placeholder="Ej: 1Z999AA10123456784" />
            </div>
            <button type="button" className="xl-track__btn"
              onClick={onVerTracking}
              disabled={!puedeVer}
              title={isNew
                ? 'Guarda la importacion primero'
                : (!base ? 'Este courier no tiene URL de rastreo configurada' : 'Abrir en el sitio del courier')}>
              Ver tracking
            </button>
          </div>

          {base && (
            <div className="xl-track__preview" role="status">
              URL: <span className="xl-track__preview-url">{previewUrl}</span>
            </div>
          )}
          {!base && (
            <p className="xl-track__warn">
              Este courier no tiene URL de rastreo configurada.{' '}
              <Link to="/couriers" className="xl-track__link">Editalo en Couriers</Link>.
            </p>
          )}
          {isNew && (
            <p className="xl-track__hint">Guarda la importacion primero para habilitar el boton.</p>
          )}
        </>
      )}
    </div>
  );
}
